import _ from "underscore";

export const SystemLogKind = {
  I: {
    id: "I",
    text: "Информация",
    color: "#212529"
  },
  W: {
    id: "W",
    text: "Предупреждение",
    color: "#ff8800"
  },
  E: {
    id: "E",
    text: "Ошибка",
    color: "#cc0000"
  },
  P: {
    id: "P",
    text: "Обработка",
    color: "#212529"
  }
};

export const ObjectClasses = {
  User: {
    id: "User",
    text: "Пользователь",
    icon: "fa-user",
    page: "user"
  },
  Role: {
    id: "Role",
    text: "Роль",
    icon: "fa-users",
    page: "role"
  },
  FctDataLoad: {
    id: "FctDataLoad",
    text: "Загрузка данных",
    icon: "fa-upload",
    page: "data-load"
  },
  SddSession: {
    id: "SddSession",
    text: "Сессия",
    icon: "fa-clock",
    page: "session"
  },
  SddDocument: {
    id: "SddDocument",
    text: "Входящий документ",
    icon: "fa-inbox",
    page: "document"
  },
  SddSessionSetting: {
    id: "SddSessionSetting",
    text: "Настройка сессий",
    icon: "fa-calculator",
    page: "session-setting"
  },
  SddContract: {
    id: "SddContract",
    text: "Договор",
    icon: "fa-file-alt",
    page: "contract"
  }
};

export const logLevelDataSourceConfig = {
  store: {
    type: 'array',
    data: _.values(SystemLogKind),
    key: 'id'
  },
  map: rec => _.extend({ value: rec.id }, rec)
}

export const formatLogKindColor = key =>
  key in SystemLogKind ? SystemLogKind[key].color : "unset";
